
import * as ExtranetService from './extranet.service'
import ExtranetSdk=ExtranetService.wimi.extranet

const global: any = window
const baseUrl = global.EXTRANET_WEBSOCKET_URL ? global.EXTRANET_WEBSOCKET_URL : 'ws://127.6.6.6:10086'

const urlAlphabet =
    'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'

const nanoid = (size = 21) => {
    let id = ''
    // A compact alternative for `for (var i = 0; i < step; i++)`.
    let i = size
    while (i--) {
        // `| 0` is more compact and faster than `Math.floor()`.
        id += urlAlphabet[(Math.random() * 64) | 0]
    }
    return id
}

export class ExtranetV2Data{
    connectCodeList: string[]=[];
    connectingCodeList: string[]=[];
}



export class ExtranetSocketV2{

    _extranetSdkService?:ExtranetSdk.Service=undefined;

    _serverInfo?:ExtranetSdk.ServiceInfo = undefined;

    public get serverInfo(){
        return this._serverInfo;
    }

    public get version(){
        return this._serverInfo?.version;
    }

    data: ExtranetV2Data = new ExtranetV2Data();

    connect(){
        this._extranetSdkService =new ExtranetSdk.Service(baseUrl)
        this._extranetSdkService.addEventListener("ServiceConnected",(event:ExtranetSdk.ServiceConnectedEvent)=>{
            // 服务连接成功
            console.log('服务连接结果:', event);
            if(event.serverInfo){
                this._serverInfo=event.serverInfo;
            }
            this.refreshChannelList();
        });
        this._extranetSdkService.addEventListener("ServiceDisconnected",(event)=>{
            console.log('服务断开结果:', event);
            if(this._serverInfo){
                this._serverInfo.extranetServerStatus = "Fault";
            }
            
        });
        this._extranetSdkService.addEventListener("LogOutput",(event)=>{
            console.log('日志输出:', event);
        });
        this._extranetSdkService.addEventListener("HeartbeatMessage",(event:ExtranetSdk.HeartbeatMessageEvent)=>{
            
            this._serverInfo=event.data;
            this.refreshChannelList();
        });
        this._extranetSdkService.addEventListener("ChannelDisconnected",(event)=>{
            console.log('通道断开:', event);
            this.refreshChannelList();

        });

        this._extranetSdkService.initialize()

    }

    close(){
        this._extranetSdkService?.shutdown();
        this._extranetSdkService=undefined;
    }


    resetSocket(){
        this.close()
        this.connect();
    }

    refreshChannelList(){
        this._extranetSdkService?.ChannelsList()
            .then((res:ExtranetSdk.ChannelInfo[])=>{
                this.data.connectCodeList = res.map(c=>c.connect_code);
                this.data.connectingCodeList = res.filter(c=>c.status==='connecting').map(c=>c.connect_code);
            });
    }


    refreshServerInfo(){
        this._extranetSdkService?.GetServiceInfo()
            .then(res=>{
                this._serverInfo=res;
            })
    }

    startRemoteConnection(connectCode){
        return this._extranetSdkService?.ChannelConnect(connectCode)
            .then(res=>{
                this.refreshChannelList();
                return res;
            })
    }

    stopRemoteConnection(connectCode){
        return this._extranetSdkService?.ChannelDisconnect(connectCode);
    }

    channelListRequest(){
        return this._extranetSdkService?.ChannelsList();
    }

}
